<div class="page-container" *ngIf="!loading && maintenance">
  <!-- Header -->
  <div class="page-header">
    <div class="header-left">
      <button mat-icon-button (click)="goBack()" matTooltip="Zurück">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div>
        <div class="header-type">
          <mat-icon class="type-icon">{{isPlanned ? 'event_repeat' : 'build'}}</mat-icon>
          <span class="type-label">{{isPlanned ? 'Planmäßige Wartung' : 'Einsatz / Reparatur'}}</span>
        </div>
        <h1>{{maintenance.title}}</h1>
        <div class="header-meta">
          <span *ngIf="customer"><mat-icon class="mi">business</mat-icon> {{customer.name}}</span>
          <span><mat-icon class="mi">electrical_services</mat-icon> {{maintenance.equipment?.name ?? '–'}}</span>
          <span><mat-icon class="mi">event</mat-icon> {{maintenance.scheduledDate | date:'dd.MM.yyyy'}}</span>
          <span *ngIf="maintenance.assignedUsers?.length"><mat-icon class="mi">group</mat-icon> {{getTechnicianNames()}}</span>
          <span *ngIf="!maintenance.assignedUsers?.length && maintenance.assignedUser"><mat-icon class="mi">person</mat-icon> {{maintenance.assignedUser.userName}}</span>
        </div>
      </div>
    </div>
    <div class="header-actions">
      <span class="status-chip large" [ngClass]="getStatusClass(maintenance.status)">
        {{getStatusLabel(maintenance.status)}}
      </span>
    </div>
  </div>

  <!-- ============================================ -->
  <!-- SERVICE CALL / REPARATUR VIEW (nicht planned) -->
  <!-- ============================================ -->
  <ng-container *ngIf="!isPlanned">
    <div class="service-content">
      <div class="section-card service-overview-card">
        <div class="section-header overview-header">
          <h2><mat-icon>dashboard</mat-icon> Einsatzübersicht</h2>
          <div class="overview-actions">
            <button mat-raised-button color="accent" (click)="setServiceCallStatus(MaintenanceStatus.Completed)" *ngIf="maintenance.status !== MaintenanceStatus.Completed">
              <mat-icon>check_circle</mat-icon> Abschließen
            </button>
            <button mat-stroked-button (click)="setServiceCallStatus(MaintenanceStatus.InProgress)" *ngIf="maintenance.status === MaintenanceStatus.Completed">
              <mat-icon>replay</mat-icon> Wiederöffnen
            </button>
            <button mat-stroked-button color="primary" (click)="editServiceCall()">
              <mat-icon>edit</mat-icon> Bearbeiten
            </button>
            <button mat-stroked-button color="warn" (click)="deleteServiceCall()">
              <mat-icon>delete</mat-icon> Löschen
            </button>
          </div>
        </div>

        <div class="service-info-grid overview-grid">
          <div class="info-tile">
            <mat-icon>event</mat-icon>
            <div>
              <span class="tile-label">Datum</span>
              <span class="tile-value">{{maintenance.scheduledDate | date:'dd.MM.yyyy'}}</span>
            </div>
          </div>
          <div class="info-tile">
            <mat-icon>group</mat-icon>
            <div>
              <span class="tile-label">Techniker</span>
              <span class="tile-value" *ngIf="maintenance.assignedUsers?.length">{{getTechnicianNames()}}</span>
              <span class="tile-value" *ngIf="!maintenance.assignedUsers?.length">{{maintenance.assignedUser?.userName ?? '–'}}</span>
            </div>
          </div>
          <div class="info-tile">
            <mat-icon>schedule</mat-icon>
            <div>
              <span class="tile-label">Arbeitszeit</span>
              <span class="tile-value">{{durationText}}</span>
            </div>
          </div>
          <div class="info-tile">
            <mat-icon>directions_car</mat-icon>
            <div>
              <span class="tile-label">Fahrzeit</span>
              <span class="tile-value">{{travelTimeText}}</span>
            </div>
          </div>
          <div class="info-tile" *ngIf="regieHours != null || regieMinutes != null">
            <mat-icon>euro</mat-icon>
            <div>
              <span class="tile-label">Regiestunden</span>
              <span class="tile-value">{{regieText}}</span>
            </div>
          </div>
          <div class="info-tile" *ngIf="maintenance.completedOn">
            <mat-icon>check_circle</mat-icon>
            <div>
              <span class="tile-label">Abgeschlossen</span>
              <span class="tile-value">{{maintenance.completedOn | date:'dd.MM.yyyy HH:mm'}}</span>
            </div>
          </div>
        </div>

        <div class="timeline-strip" *ngIf="departureFromOffice || arrivalTime || departureTime || returnToOffice">
          <div class="timeline-step" *ngIf="departureFromOffice">
            <mat-icon>departure_board</mat-icon>
            <span>Abfahrt Büro</span>
            <strong>{{departureFromOffice}}</strong>
          </div>
          <div class="timeline-step" *ngIf="arrivalTime">
            <mat-icon>login</mat-icon>
            <span>Ankunft</span>
            <strong>{{arrivalTime}}</strong>
          </div>
          <div class="timeline-step" *ngIf="departureTime">
            <mat-icon>logout</mat-icon>
            <span>Abreise</span>
            <strong>{{departureTime}}</strong>
          </div>
          <div class="timeline-step" *ngIf="returnToOffice">
            <mat-icon>home</mat-icon>
            <span>Rückkehr Büro</span>
            <strong>{{returnToOffice}}</strong>
          </div>
        </div>
      </div>

      <div class="section-card service-report-card" *ngIf="serviceDescription || initialSituation || workItems.length > 0 || problems.length > 0">
        <div class="section-header">
          <h2><mat-icon>article</mat-icon> Einsatzbericht</h2>
        </div>

        <div class="report-section" *ngIf="serviceDescription">
          <h3><mat-icon>notes</mat-icon> Allgemeine Beschreibung</h3>
          <p class="service-description">{{serviceDescription}}</p>
        </div>

        <div class="report-section" *ngIf="initialSituation">
          <h3><mat-icon>visibility</mat-icon> Ist-Zustand bei Ankunft</h3>
          <p class="service-description">{{initialSituation}}</p>
        </div>

        <div class="report-section" *ngIf="workItems.length > 0">
          <h3><mat-icon>description</mat-icon> Durchgeführte Arbeiten</h3>
          <div class="work-items-list">
            <div class="work-item" *ngFor="let item of workItems; let i = index">
              <span class="work-item-num">{{i + 1}}.</span>
              <span class="work-item-text">{{item}}</span>
            </div>
          </div>
        </div>

        <div class="report-section" *ngIf="problems.length > 0">
          <h3><mat-icon>report_problem</mat-icon> Probleme &amp; Lösungen</h3>
          <div class="problems-list">
            <div class="problem-entry" *ngFor="let prob of problems; let i = index">
              <div class="problem-header">
                <span class="problem-num">Problem {{i + 1}}</span>
              </div>
              <div class="problem-detail">
                <span class="detail-label">Beschreibung:</span>
                <span>{{prob.description}}</span>
              </div>
              <div class="problem-detail" *ngIf="prob.solution">
                <span class="detail-label">Lösung:</span>
                <span>{{prob.solution}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Regiestunden -->
      <div class="section-card" *ngIf="regieLines.length > 0">
        <div class="section-header">
          <h2><mat-icon>euro</mat-icon> Regiestunden</h2>
          <span class="ack-pill" [class.pending]="!regieAcknowledged">
            <mat-icon>{{regieAcknowledged ? 'verified' : 'edit_note'}}</mat-icon>
            {{regieAcknowledged ? 'Vom Kunden unterschrieben' : 'Noch nicht vom Kunden unterschrieben'}}
          </span>
        </div>
        <div class="regie-table detail">
          <div class="regie-row regie-head">
            <span>Tätigkeit</span>
            <span>Stunden</span>
            <span>Satz</span>
            <span>Summe</span>
            <span>Status</span>
          </div>
          <div class="regie-row" *ngFor="let line of regieLines">
            <span>{{line.label}}</span>
            <span>{{line.hours | number:'1.2-2'}} h</span>
            <span>{{line.hourlyRate | number:'1.2-2'}} €/h</span>
            <strong>{{line.hours * line.hourlyRate | currency:'EUR':'symbol':'1.2-2'}}</strong>
            <span class="line-ack" [class.pending]="!line.isCustomerAcknowledged">
              {{line.isCustomerAcknowledged ? 'signiert' : 'offen'}}
            </span>
          </div>
          <div class="regie-total">
            <span>Gesamt</span>
            <strong>{{getRegieTotal(regieLines) | currency:'EUR':'symbol':'1.2-2'}}</strong>
          </div>
        </div>
      </div>

      <!-- Materials -->
      <div class="section-card" *ngIf="materials.length > 0">
        <div class="section-header">
          <h2><mat-icon>inventory_2</mat-icon> Verwendetes Material</h2>
        </div>
        <div class="service-material-list">
          <div class="service-mat-row" *ngFor="let mat of materials">
            <span class="mat-name">{{mat.name}}</span>
            <span class="mat-amount">{{mat.quantity}} {{mat.unit}}</span>
            <span class="mat-amount" *ngIf="mat.unitPrice && mat.unitPrice > 0">{{mat.unitPrice | currency:'EUR':'symbol':'1.2-2'}} / {{mat.unit}}</span>
          </div>
        </div>
      </div>

      <!-- Standard-Material vom Kunden -->
      <div class="section-card" *ngIf="customerMaterials.length > 0">
        <div class="section-header">
          <h2><mat-icon>store</mat-icon> Standard-Material (Kunde)</h2>
        </div>
        <div class="service-material-list">
          <div class="service-mat-row standard" *ngFor="let mat of customerMaterials">
            <span class="mat-name">{{mat.name}}</span>
            <span class="mat-amount">{{mat.quantity}} {{mat.unit}}</span>
          </div>
        </div>
      </div>

      <!-- Photos -->
      <div class="section-card">
        <div class="section-header">
          <h2><mat-icon>photo_library</mat-icon> Fotodokumentation ({{photos.length}})</h2>
          <button mat-stroked-button color="primary" (click)="triggerAddPhoto()">
            <mat-icon>add_a_photo</mat-icon> Fotos hinzufügen
          </button>
        </div>
        <input #addPhotoInput type="file" accept="image/*" multiple hidden (change)="onAddPhotos($event)">
        <div class="photo-grid" *ngIf="photos.length > 0">
          <div class="photo-thumb" *ngFor="let photo of photos; let i = index">
            <img [src]="photo.dataUrl" [alt]="photo.name" (click)="openPhoto(i)">
            <button mat-icon-button class="photo-delete-btn" (click)="removePhoto(i); $event.stopPropagation()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
        <div *ngIf="photos.length === 0" class="empty-section small">
          <p>Noch keine Fotos. Klicken Sie auf "Fotos hinzufügen" um Bilder hochzuladen.</p>
        </div>
      </div>

      <!-- Techniker-Unterschrift -->
      <div class="section-card" *ngIf="techSignatureDataUrl">
        <div class="section-header">
          <h2><mat-icon>draw</mat-icon> Unterschrift Techniker</h2>
        </div>
        <div class="signature-display">
          <span class="sig-name" *ngIf="techSigneeName">{{techSigneeName}}</span>
          <img [src]="techSignatureDataUrl" alt="Unterschrift Techniker" class="sig-image">
        </div>
      </div>

      <!-- Signature -->
      <div class="section-card">
        <div class="section-header">
          <h2><mat-icon>draw</mat-icon> Unterschrift Kunde</h2>
          <button mat-stroked-button color="primary" (click)="openSignatureEditor()">
            <mat-icon>{{customerSignatureButtonIcon}}</mat-icon>
            {{customerSignatureButtonLabel}}
          </button>
        </div>
        <div class="customer-ack-status" *ngIf="maintenance?.customerAcknowledged && !hasOpenRegieLines">
          <mat-icon class="ack-icon">verified</mat-icon>
          <span>Kunde wurde über Stunden und Arbeiten aufgeklärt und hat zugestimmt.</span>
        </div>
        <div class="customer-ack-status pending" *ngIf="hasOpenRegieLines">
          <mat-icon class="ack-icon">edit_note</mat-icon>
          <span>Es gibt offene Regiestunden. Bitte die Zustimmung erneut einholen.</span>
        </div>
        <div class="signature-display" *ngIf="signatureDataUrl">
          <span class="sig-name" *ngIf="customerSigneeName">{{customerSigneeName}}</span>
          <img [src]="signatureDataUrl" alt="Unterschrift" class="sig-image">
        </div>
        <div *ngIf="!signatureDataUrl" class="empty-section small">
          <p>Noch keine Unterschrift vorhanden.</p>
        </div>
      </div>

      <!-- Signature Editor Overlay -->
      <div class="sig-editor-overlay" *ngIf="showSignatureEditor">
        <div class="sig-editor-card">
          <div class="section-header">
            <h2><mat-icon>draw</mat-icon> Unterschrift {{signatureDataUrl ? 'ändern' : 'hinzufügen'}}</h2>
            <button mat-icon-button (click)="cancelSignatureEdit()" [disabled]="savingSignature">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <mat-form-field appearance="outline" class="full-w">
            <mat-label>Name des Unterzeichners</mat-label>
            <input matInput [(ngModel)]="editSigneeName" placeholder="Vor- und Nachname">
          </mat-form-field>
          <p class="sig-hint">Bitte hier unterschreiben:</p>
          <div class="sig-canvas-wrapper">
            <canvas #editSigCanvas class="sig-canvas"></canvas>
            <button mat-icon-button class="clear-sig" (click)="clearSigCanvas()" matTooltip="Unterschrift löschen">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
          <div class="sig-editor-actions">
            <button mat-stroked-button (click)="cancelSignatureEdit()" [disabled]="savingSignature">
              Abbrechen
            </button>
            <button mat-raised-button color="primary" (click)="saveSignature()" [disabled]="savingSignature || (!sigEdited && !editSigneeName && !signatureDataUrl)">
              <mat-spinner *ngIf="savingSignature" diameter="18" class="btn-spinner"></mat-spinner>
              <mat-icon *ngIf="!savingSignature">save</mat-icon>
              {{savingSignature ? 'Speichert...' : 'Speichern'}}
            </button>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="service-actions">
        <button mat-raised-button color="primary" (click)="downloadServicePDF()" class="action-btn" [disabled]="!hasStoredServicePdf">
          <mat-icon>picture_as_pdf</mat-icon> PDF herunterladen
        </button>
        <button mat-raised-button color="accent" (click)="sendServicePdfByEmail()" class="action-btn" [disabled]="sendingPdfEmail || !hasStoredServicePdf">
          <mat-icon *ngIf="!sendingPdfEmail">send</mat-icon>
          <mat-spinner *ngIf="sendingPdfEmail" diameter="18" class="btn-spinner"></mat-spinner>
          PDF versenden
        </button>
        <button mat-stroked-button (click)="generateReport()" class="action-btn">
          <mat-icon>print</mat-icon> Report-Dialog öffnen
        </button>
      </div>

      <!-- Report-Verlauf (gespeicherte Versionen) -->
      <div class="section-card report-history-card" *ngIf="reportVersions.length > 0">
        <div class="section-header compact">
          <h2><mat-icon>history</mat-icon> Report-Verlauf</h2>
          <span class="report-count">{{reportVersions.length}}</span>
        </div>
        <div class="report-version" *ngFor="let r of reportVersions">
          <mat-icon class="rv-icon">picture_as_pdf</mat-icon>
          <div class="rv-info">
            <span class="rv-name">{{r.fileName}}</span>
            <span class="rv-date">{{r.createdAtUtc | date:'dd.MM.yyyy HH:mm'}}</span>
          </div>
          <button mat-icon-button matTooltip="Öffnen / Herunterladen" (click)="openReportVersion(r)">
            <mat-icon>download</mat-icon>
          </button>
        </div>
      </div>
    </div>


    <!-- Photo Lightbox -->
    <div class="photo-lightbox" *ngIf="selectedPhotoIndex !== null" (click)="closePhotoViewer()">
      <button mat-icon-button class="lb-close" (click)="closePhotoViewer()">
        <mat-icon>close</mat-icon>
      </button>
      <button mat-icon-button class="lb-prev" (click)="prevPhoto(); $event.stopPropagation()" *ngIf="selectedPhotoIndex > 0">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <img [src]="photos[selectedPhotoIndex].dataUrl" class="lb-image" (click)="$event.stopPropagation()">
      <button mat-icon-button class="lb-next" (click)="nextPhoto(); $event.stopPropagation()" *ngIf="selectedPhotoIndex < photos.length - 1">
        <mat-icon>chevron_right</mat-icon>
      </button>
      <span class="lb-counter">{{selectedPhotoIndex + 1}} / {{photos.length}}</span>
    </div>
  </ng-container>

  <!-- ============================================ -->
  <!-- PLANNED MAINTENANCE VIEW (Checklisten etc.) -->
  <!-- ============================================ -->
  <ng-container *ngIf="isPlanned">
    <!-- Progress Bar -->
    <div class="progress-section" *ngIf="totalChecklistItems > 0">
      <div class="progress-header">
        <span class="progress-label">Fortschritt</span>
        <span class="progress-value">{{completedChecklistItems}} / {{totalChecklistItems}} ({{checklistProgress}}%)</span>
      </div>
      <mat-progress-bar mode="determinate" [value]="checklistProgress"
                         [color]="allChecklistsComplete ? 'primary' : 'accent'"
                         class="main-progress"></mat-progress-bar>
    </div>

    <div class="content-grid">
      <!-- Left: Checklists -->
      <div class="content-main">
        <div class="section-card">
          <div class="section-header">
            <h2><mat-icon>checklist</mat-icon> Checklisten</h2>
            <div class="section-header-actions" *ngIf="!isCompleted">
              <button mat-stroked-button [matMenuTriggerFor]="templateMenu" *ngIf="templates.length > 0">
                <mat-icon>library_add_check</mat-icon>
                Vorlage anwenden
              </button>
              <mat-menu #templateMenu="matMenu">
                <button mat-menu-item *ngFor="let t of templates" (click)="applyTemplate(t)">
                  <mat-icon>checklist_rtl</mat-icon>
                  <span>{{t.name || 'Vorlage'}} ({{t.items?.length ?? 0}})</span>
                </button>
              </mat-menu>
              <button mat-stroked-button color="primary" (click)="showNewChecklist = !showNewChecklist">
                <mat-icon>{{showNewChecklist ? 'close' : 'add'}}</mat-icon>
                {{showNewChecklist ? 'Abbrechen' : 'Neue Checkliste'}}
              </button>
            </div>
          </div>

          <div *ngIf="showNewChecklist" class="inline-form">
            <mat-form-field appearance="outline" class="flex-grow">
              <mat-label>Name der Checkliste</mat-label>
              <input matInput [(ngModel)]="newChecklistName" placeholder="z.B. Hauptverteiler EG"
                     (keyup.enter)="addChecklist()">
            </mat-form-field>
            <button mat-raised-button color="primary" (click)="addChecklist()" [disabled]="!newChecklistName.trim()">
              Erstellen
            </button>
          </div>

          <div *ngIf="checklists.length === 0 && !showNewChecklist" class="empty-section">
            <mat-icon>playlist_add</mat-icon>
            <p>Noch keine Checklisten. Erstellen Sie eine für jeden Verteiler.</p>
          </div>

          <div class="checklist-list">
            <mat-expansion-panel *ngFor="let cl of checklists"
                                 [expanded]="!isChecklistCollapsed(cl)"
                                 (expandedChange)="onChecklistExpandedChange(cl, $event)"
                                 class="checklist-panel"
                                 [class.cl-done]="getChecklistCompletionPercent(cl) === 100">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="cl-icon">{{getChecklistCompletionPercent(cl) === 100 ? 'check_circle' : 'radio_button_unchecked'}}</mat-icon>
                  {{cl.name || 'Checkliste'}}
                </mat-panel-title>
                <mat-panel-description>
                  <span class="cl-count">{{getCheckedCount(cl)}} / {{cl.items?.length ?? 0}}</span>
                  <mat-progress-bar mode="determinate" [value]="getChecklistCompletionPercent(cl)" class="cl-progress"></mat-progress-bar>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div class="checklist-items">
                <div class="cl-item" *ngFor="let item of cl.items; let i = index; let last = last" [class.checked]="item.isChecked">
                  <div class="cl-item-main">
                    <mat-checkbox class="cl-item-check" [checked]="item.isChecked" (change)="toggleChecklistItem(item)"
                                  [disabled]="isCompleted" color="primary">
                      {{item.description}}
                    </mat-checkbox>
                    <span class="cl-item-actions">
                      <button mat-icon-button class="item-remark" matTooltip="Bemerkung"
                              [class.active]="isRemarksOpen(item)"
                              (click)="toggleRemarks(item)">
                        <mat-icon>sticky_note_2</mat-icon>
                      </button>
                      <button mat-icon-button class="item-move" matTooltip="Nach oben" *ngIf="!isCompleted"
                              [disabled]="i === 0" (click)="moveChecklistItem(cl, item, -1)">
                        <mat-icon>arrow_upward</mat-icon>
                      </button>
                      <button mat-icon-button class="item-move" matTooltip="Nach unten" *ngIf="!isCompleted"
                              [disabled]="last" (click)="moveChecklistItem(cl, item, 1)">
                        <mat-icon>arrow_downward</mat-icon>
                      </button>
                      <button mat-icon-button class="item-delete" matTooltip="Entfernen" *ngIf="!isCompleted"
                              (click)="deleteChecklistItem(item)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </span>
                  </div>
                  <div class="cl-item-remarks" *ngIf="isRemarksOpen(item)">
                    <mat-icon class="remarks-icon">subdirectory_arrow_right</mat-icon>
                    <input class="remarks-input" [(ngModel)]="item.remarks"
                           placeholder="Bemerkung..."
                           (blur)="saveItemRemarks(item)"
                           (keyup.enter)="saveItemRemarks(item)"
                           [readonly]="isCompleted">
                  </div>
                </div>

                <div *ngIf="activeChecklistId === cl.id && !isCompleted" class="add-item-form">
                  <input class="add-item-input" [(ngModel)]="newItemText"
                         placeholder="Neuen Prüfpunkt eingeben..."
                         (keyup.enter)="addChecklistItem(cl.id)">
                  <button mat-icon-button color="primary" (click)="addChecklistItem(cl.id)" [disabled]="!newItemText.trim()">
                    <mat-icon>add_circle</mat-icon>
                  </button>
                  <button mat-icon-button (click)="cancelAddItem()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <button *ngIf="activeChecklistId !== cl.id && !isCompleted" mat-button color="primary"
                        (click)="startAddingItem(cl.id)" class="add-item-btn">
                  <mat-icon>add</mat-icon> Prüfpunkt hinzufügen
                </button>
              </div>

              <mat-action-row>
                <button mat-button (click)="renameChecklist(cl)" *ngIf="!isCompleted">
                  <mat-icon>edit</mat-icon> Umbenennen
                </button>
                <button mat-button (click)="saveChecklistAsTemplate(cl)" *ngIf="!isCompleted && (cl.items?.length ?? 0) > 0">
                  <mat-icon>bookmark_add</mat-icon> Als Vorlage speichern
                </button>
                <button mat-button color="warn" (click)="deleteChecklist(cl)" *ngIf="!isCompleted">
                  <mat-icon>delete_outline</mat-icon> Checkliste löschen
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </div>
        </div>

        <!-- Photos -->
        <div class="section-card">
          <div class="section-header">
            <h2><mat-icon>photo_library</mat-icon> Fotos &amp; Anhänge ({{photos.length}})</h2>
            <button mat-stroked-button color="primary" (click)="triggerAddPhoto()" *ngIf="!isCompleted">
              <mat-icon>add_a_photo</mat-icon> Hinzufügen
            </button>
          </div>
          <input #addPhotoInputPlanned type="file" accept="image/*,application/pdf" multiple hidden (change)="onAddPhotos($event)">
          <div class="photo-grid" *ngIf="photos.length > 0">
            <div class="photo-thumb" *ngFor="let photo of photos; let i = index">
              <img [src]="photo.dataUrl" [alt]="photo.name" (click)="openPhoto(i)">
              <button mat-icon-button class="photo-delete-btn" (click)="removePhoto(i); $event.stopPropagation()" *ngIf="!isCompleted">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          <div *ngIf="photos.length === 0" class="empty-section small">
            <p>Noch keine Fotos oder Anhänge.</p>
          </div>
        </div>
      </div>

      <!-- Right: Sidebar -->
      <div class="content-sidebar">
        <div class="section-card" *ngIf="!isCompleted">
          <h3>Aktionen</h3>
          <div class="action-buttons">
            <button mat-raised-button color="primary" (click)="startMaintenance()"
                    *ngIf="maintenance.status === 'Planned' || maintenance.status === 'Overdue'">
              <mat-icon>play_arrow</mat-icon> Wartung starten
            </button>
            <button mat-raised-button color="accent" (click)="completeMaintenance()"
                    *ngIf="maintenance.status === 'InProgress'">
              <mat-icon>check</mat-icon> Abschließen
            </button>
            <button mat-stroked-button (click)="generateReport()"
                    *ngIf="maintenance.status === 'InProgress' || allChecklistsComplete">
              <mat-icon>description</mat-icon> Report erstellen
            </button>
            <button mat-stroked-button (click)="downloadServicePDF()" *ngIf="hasStoredServicePdf">
              <mat-icon>picture_as_pdf</mat-icon> Gespeicherten Bericht herunterladen
            </button>
            <button mat-stroked-button (click)="editPlannedMaintenance()">
              <mat-icon>edit</mat-icon> Grunddaten bearbeiten
            </button>
          </div>
        </div>

        <div class="section-card" *ngIf="isCompleted">
          <h3>Abgeschlossen</h3>
          <p class="completed-info">
            <mat-icon class="mi">event</mat-icon>
            {{maintenance.completedOn | date:'dd.MM.yyyy HH:mm'}}
          </p>
          <button mat-raised-button color="primary" (click)="downloadServicePDF()"
                  [disabled]="!hasStoredServicePdf">
            <mat-icon>picture_as_pdf</mat-icon> Gespeicherten Bericht herunterladen
          </button>
          <button mat-stroked-button (click)="generateReport()" style="margin-top: 8px;">
            <mat-icon>description</mat-icon> Report neu erstellen / anzeigen
          </button>
          <button mat-stroked-button (click)="reopenMaintenance()" style="margin-top: 8px;">
            <mat-icon>replay</mat-icon> Wiederöffnen
          </button>
          <button mat-stroked-button (click)="editPlannedMaintenance()" style="margin-top: 8px;">
            <mat-icon>edit</mat-icon> Grunddaten bearbeiten
          </button>
        </div>

        <!-- Report-Verlauf (gespeicherte Versionen) -->
        <div class="section-card report-history-card" *ngIf="reportVersions.length > 0">
          <h3><mat-icon class="mi">history</mat-icon> Report-Verlauf</h3>
          <div class="report-version" *ngFor="let r of reportVersions">
            <mat-icon class="rv-icon">picture_as_pdf</mat-icon>
            <div class="rv-info">
              <span class="rv-name">{{r.fileName}}</span>
              <span class="rv-date">{{r.createdAtUtc | date:'dd.MM.yyyy HH:mm'}}</span>
            </div>
            <button mat-icon-button matTooltip="Öffnen / Herunterladen" (click)="openReportVersion(r)">
              <mat-icon>download</mat-icon>
            </button>
          </div>
        </div>

        <div class="section-card info-card">
          <h3>Details</h3>
          <div class="info-row">
            <span class="info-label">Angelegt</span>
            <span>{{maintenance.scheduledDate | date:'dd.MM.yyyy'}}</span>
          </div>
          <div class="info-row" *ngIf="maintenance.dueDate">
            <span class="info-label">Fällig bis</span>
            <span>{{maintenance.dueDate | date:'dd.MM.yyyy'}}</span>
          </div>
          <div class="info-row" *ngIf="isPlanned">
            <span class="info-label">Intervall</span>
            <span>{{getRecurrenceLabel(maintenance.recurrenceType)}}</span>
          </div>
          <div class="info-row" *ngIf="maintenance.assignedUsers?.length">
            <span class="info-label">Techniker</span>
            <span>{{getTechnicianNames()}}</span>
          </div>
          <div class="info-row" *ngIf="!maintenance.assignedUsers?.length && maintenance.assignedUser">
            <span class="info-label">Techniker</span>
            <span>{{maintenance.assignedUser.userName}}</span>
          </div>
          <div class="info-row" *ngIf="maintenance.notificationsEnabled">
            <span class="info-label">Erinnerung</span>
            <span>{{maintenance.notificationLeadTimeDays}} Tage vorher</span>
          </div>
          <div class="info-row" *ngIf="maintenance.notes">
            <span class="info-label">Notizen</span>
            <span>{{maintenance.notes}}</span>
          </div>
        </div>

        <!-- Materials -->
        <div class="section-card">
          <div class="section-header compact">
            <h3>Material</h3>
            <button mat-icon-button (click)="showMaterialForm = !showMaterialForm" *ngIf="!isCompleted">
              <mat-icon>{{showMaterialForm ? 'close' : 'add'}}</mat-icon>
            </button>
          </div>

          <div *ngIf="showMaterialForm" class="material-form-compact">
            <mat-form-field appearance="outline" class="full-w">
              <mat-label>Bezeichnung</mat-label>
              <input matInput [(ngModel)]="newMaterial.name" (keyup.enter)="addMaterial()">
            </mat-form-field>
            <div class="mat-row">
              <mat-form-field appearance="outline" class="small-f">
                <mat-label>Menge</mat-label>
                <input matInput type="number" [(ngModel)]="newMaterial.quantity">
              </mat-form-field>
              <mat-form-field appearance="outline" class="small-f">
                <mat-label>Einheit</mat-label>
                <input matInput [(ngModel)]="newMaterial.unit">
              </mat-form-field>
              <mat-form-field appearance="outline" class="small-f">
                <mat-label>Preis</mat-label>
                <input matInput type="number" [(ngModel)]="newMaterial.unitPrice" min="0" step="0.01">
              </mat-form-field>
              <button mat-raised-button color="primary" (click)="addMaterial()" [disabled]="!newMaterial.name?.trim()">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>

          <div *ngIf="materials.length === 0 && !showMaterialForm" class="empty-section small">
            <p>Kein Material zugeordnet</p>
          </div>

          <div class="material-list-compact">
            <div class="mat-item" *ngFor="let mat of materials">
              <div class="mat-item-info">
                <strong>{{mat.name}}</strong>
                <span class="mat-qty">{{mat.quantity}} {{mat.unit}}</span>
                <span class="mat-qty" *ngIf="mat.unitPrice && mat.unitPrice > 0">{{mat.unitPrice | currency:'EUR':'symbol':'1.2-2'}} / {{mat.unit}}</span>
              </div>
              <button mat-icon-button class="item-delete" (click)="deleteMaterial(mat)" *ngIf="!isCompleted">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- Standard-Material vom Kunden -->
        <div class="section-card" *ngIf="customerMaterials.length > 0">
          <div class="section-header compact">
            <h3><mat-icon class="customer-mat-icon">store</mat-icon> Standard-Material</h3>
          </div>
          <div class="material-list-compact">
            <div class="mat-item standard" *ngFor="let mat of customerMaterials">
              <div class="mat-item-info">
                <strong>{{mat.name}}</strong>
                <span class="mat-qty">{{mat.quantity}} {{mat.unit}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Photo Lightbox (Planned) -->
    <div class="photo-lightbox" *ngIf="selectedPhotoIndex !== null" (click)="closePhotoViewer()">
      <button mat-icon-button class="lb-close" (click)="closePhotoViewer()">
        <mat-icon>close</mat-icon>
      </button>
      <button mat-icon-button class="lb-prev" (click)="prevPhoto(); $event.stopPropagation()" *ngIf="selectedPhotoIndex > 0">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <img [src]="photos[selectedPhotoIndex].dataUrl" class="lb-image" (click)="$event.stopPropagation()">
      <button mat-icon-button class="lb-next" (click)="nextPhoto(); $event.stopPropagation()" *ngIf="selectedPhotoIndex < photos.length - 1">
        <mat-icon>chevron_right</mat-icon>
      </button>
      <span class="lb-counter">{{selectedPhotoIndex + 1}} / {{photos.length}}</span>
    </div>
  </ng-container>
</div>

<!-- Loading -->
<div *ngIf="loading" class="loading-page">
  <mat-spinner diameter="48"></mat-spinner>
</div>
